import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TaskView, ActiveEmployee } from 'planner-shared';

import { ProblemInstanceService } from '../problem-instance/problem-instance.service';
import { TaskWorkShiftCompatibility } from '../../models/task-work-shift-compatibility.model';
import { BaseTask } from '../../models';
import { SyncedTaskPair } from '../../models/synced-task-pair.model';

@Injectable({
    providedIn: 'root'
})
export class TaskValidateService {
    private readonly problemInstanceService = inject(ProblemInstanceService);


    public isTaskValidForEmployee(employee: ActiveEmployee, task: TaskView): Observable<boolean> {
        return this.problemInstanceService.getProblemInstance().pipe(
            map(result => {
                return (
                    this.taskCompatible(task, employee.workHourId, result.problemInstance.taskWorkShiftCompatibility) &&
                    this.taskIsNotAlreadyAssignedToEmployee(task.originalTaskId, employee.tasks) &&
                    this.syncedNotAlreadyAssignedToEmployee(task, employee.tasks, result.problemInstance.syncedTaskPairs)
                );
            })
        );
    }

    private taskCompatible(
        task: TaskView,
        employeeWorkHourId: string,
        taskWorkShiftCompatibility: TaskWorkShiftCompatibility[]
    ): boolean {
        const routePlannerTaskId = task.routePlannerTaskId;
        const originalTaskId = task.originalTaskId;
        let compatibilities = taskWorkShiftCompatibility.find(
            compatibility => compatibility.routePlannerTaskId === routePlannerTaskId
        );
        if (compatibilities === undefined) {
            compatibilities = taskWorkShiftCompatibility.find(
                compatibility => compatibility.routePlannerTaskId === originalTaskId
            );
        }
        if (compatibilities) {
            return compatibilities?.compatibleWorkHourIds.some(workHourId => workHourId === employeeWorkHourId);
        }
        return false;
    }

    private taskIsNotAlreadyAssignedToEmployee(originalTaskId: string, assignedTaskViewList: BaseTask[]): boolean {
        if (assignedTaskViewList == null) {
            return true;
        }

        const taskFound = assignedTaskViewList.some(task => task.originalTaskId === originalTaskId);
        return !taskFound;
    }

    private syncedNotAlreadyAssignedToEmployee(task: TaskView, assignedTaskViewList: BaseTask[], syncedTaskPairs: SyncedTaskPair[]): boolean {
        if (assignedTaskViewList == null || !task.isSynced) {
            return true;
        }
        const syncedWithAsDependent = syncedTaskPairs.filter(taskPair => taskPair.syncedWithTaskId === task.originalTaskId).map(taskPair => taskPair.syncedMasterTaskId);
        let masterTaskId: string;
        if(syncedWithAsDependent.length > 0){
            masterTaskId = syncedWithAsDependent[0];
        }else{
            masterTaskId = task.originalTaskId;
        }
        const syncedWith= syncedTaskPairs.filter(taskPair => taskPair.syncedMasterTaskId === masterTaskId)
        .map(taskPair => taskPair.syncedWithTaskId).concat(masterTaskId).filter(taskId => taskId !== task.originalTaskId);
        const taskFound = assignedTaskViewList.some(task => syncedWith.includes(task.originalTaskId));
        return !taskFound;
    }
}
